import React from 'react';
export function Card({
  title,
  children,
  actions
}) {
  return <div className="border border-gray-200 rounded-lg overflow-hidden mb-4" data-id="element-477">
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex justify-between items-center" data-id="element-478">
        <h3 className="font-medium text-gray-700" data-id="element-479">{title}</h3>
        {actions && <div className="flex gap-2" data-id="element-480">{actions}</div>}
      </div>
      <div className="p-4" data-id="element-481">{children}</div>
    </div>;
}